<template>
  <LoginWrapper>
    <template v-slot:main>
      <h2 class="login-title">Complete Account Registration</h2>

      <div v-if="!hasVerificationCode">
        <NotificationBar type="error">
          <NotificationBarTitle>No verification code set. Please check your email for the link</NotificationBarTitle>
        </NotificationBar>

        <div class="row">
          <div class="col-12 text-left">
            <router-link to="/login" class="login-small-links">Back</router-link>
          </div>
        </div>
      </div>
      <div v-if="hasVerificationCode">
        <Spinner v-if="submitting" />
        <NotificationBar type="error" v-if="!submitting && accountCompletionError">
          <NotificationBarTitle>{{accountCompletionError}}</NotificationBarTitle>
        </NotificationBar>

        <div class="row" v-if="!submitting && accountCompletionError">
          <div class="col-12 text-left">
            <router-link to="/login" class="login-small-links">Back</router-link>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:sidebar>
      <div class="login-side-title">Welcome</div>
        Already have an account?<br />
        <div class="mt-2">
          <router-link to="/login" class="login-sidebar-button">Sign In</router-link>
        </div>
    </template>
  </LoginWrapper>
</template>


<script>
import form from '@/mixins/form'
import LoginWrapper from '@/modules/core/components/loginWrapper'

export default {
  name: 'AccountRegistrationComplete',
  mixins: [form],
  components: {
    LoginWrapper
  },
  data: () => {
    return {
      verificationCode: '',
      submitting: false,
      accountCompletionError: '',
    };
  },
  computed: {
    hasVerificationCode() {
      return this.verificationCode && this.verificationCode != ''
    }
  },
  mounted() {
    // Copy code which should be set from the verification link in the email
    // Should really be no other way of getting to this page
    this.verificationCode = this.$route.query.code || ''
    
    // Request the basic info for the code to verify it's still valid?
    if(this.hasVerificationCode)
      this.onCompleteRegistration()
  },
  methods: {
    onCompleteRegistration() {

      this.submitting = true
      this.accountCompletionError = ''

      try {
        this.$api.post('/account/registration/complete', {
          verificationCode: this.verificationCode,
        })
        .then(response => {
          // Setup auth token
          this.$authService.setAuthToken(response.data.token, true);
          this.$socketService.connect()

          // Direct to the dashboard. Will re-direct to account activation
          this.$router.push("/")
        })
        .catch(err => {
          // Process errors
          this.accountCompletionError = this.processFormResponse(err).errorMessage
        })
        .finally(() => {
          this.submitting = false
        })
      } catch(err) {
        this.accountCompletionError = 'Error while processing registration. If this continues, please check your internet connection or contact Synergy Software'
        this.submitting = false
      }
    }
  }
}
</script>